import { NotEnoughRubyIcon } from '@wwe-portal/ui/components/icons/not-enought-ruby-icon';
import { Dialog, CommonDialogLayout } from '@wwe-portal/ui/components/dialog';

export interface OutStockRubyDialogProps {
  onClose?: () => void;
  onChange?: () => void;
  open?: boolean;
  data?: {
    actionElement?: React.ReactNode;
  };
}
export function OutStockRubyDialog({
  onClose,
  open = true,
  data,
}: Readonly<OutStockRubyDialogProps>) {
  return (
    <Dialog
      onOpenChange={(isOpen: boolean) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={data?.actionElement}
        closable
        dataId="OutStockRubyDialog"
        descriptionElement={
          <div className="mt-5">
            <p className="text-text300 mb-2 text-xl font-semibold leading-6">
              Not enough Rubies
            </p>
            <span className="text-text400 text-sm font-medium leading-[26px]">
              Buy Ruby Packs in the Special Offers Shop
            </span>
          </div>
        }
        hasBackground
        imageElement={
          <div className="border-text700 flex size-[80px] items-center justify-center rounded-full border-4 border-solid">
            <NotEnoughRubyIcon className="size-[60px]" />
          </div>
        }
        layoutClass="px-6"
        onClose={onClose}
        titleElement={undefined}
      />
    </Dialog>
  );
}

export default OutStockRubyDialog;
